<template>
  <form-group class="pa-0">
    <v-list>
      <v-subheader class="h2Header secondary300 mb-3">
        <v-row>
          Usuários selecionados
          <v-btn
            v-if="users.length >= 1"
            text
            @click="removeAll()"
          >
            <v-icon size="20">
              mdi-close
            </v-icon>
            Remover todos
          </v-btn>
        </v-row>
      </v-subheader>
      <v-list-item-group
        color="primary"
        style="height: 400px; overflow: auto;"
        class="custom-scroll"
      >
        <v-list-item
          v-for="(user, idx) in users"
          :key="makeKey('item', user.name, idx)"
          @click="removeUser(user.id)"
        >
          <v-list-item-content class="text2 secondary300">
            {{ user.name ? user.name : user.id }}
          </v-list-item-content>
          <v-list-item-avatar
            size="20"
          >
            <v-icon size="20">
              mdi-close
            </v-icon>
          </v-list-item-avatar>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </form-group>
</template>

<script>
import CrudListSelectButtonMixin from '@/app/arch/components/crud/crud-mixins/CrudListSelectButtonMixin';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';

export default {
  name: 'NotificationUserSelected',
  components: { FormGroup },
  mixins: [CrudListSelectButtonMixin],
  data: () => ({
    users: [],
  }),
  computed: {
    handleList() {
      return (userListId) => this.handleNotificationList(userListId);
    },
  },
  watch: {
    rows: {
      deep: true,
      immediate: true,
      handler(rows) {
        if (Array.isArray(rows)) {
          this.updateInList();
          this.setUsers(
            rows.length >= 1
              ? rows.map(
                ({ id, username }) => ({
                  id,
                  name: username,
                }),
              ) : rows,
          );
        }
      },
    },
    users: {
      deep: true,
      immediate: true,
      handler(users) {
        if (Array.isArray(users)) {
          this.handleList(
            users.length >= 1 ? users.map(
              ({ id }) => id,
            ) : users,
          );
        }
      },
    },
  },
  methods: {
    setUsers(users = []) {
      this.$nextTick(
        () => {
          this.users = users;
        },
      );
    },
    removeUser(id) {
      this.users = this.removeById(
        id,
        this.users,
      );
      this.rows = this.removeById(
        id,
        this.rows,
      );
    },
    removeById(id, list = []) {
      return list.filter(
        (item) => item.id !== id,
      );
    },
    removeAll() {
      this.users = [];
      this.rows = [];
    },
    updateInList() {
      this.$root.$emit('update-selected-all-rows', this.rows);
    },
  },
  inject: {
    handleNotificationList: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
